var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-alert",class:[
    _vm.type ? ("v-alert--" + _vm.type) : '',
    _vm.size ? ("v-alert--" + _vm.size) : '',
    {'v-alert--full-width': _vm.fullWidth} ]},[_c('icon-info',{staticClass:"v-alert__icon mr-1"}),_c('div',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }